import React, { useState, useEffect } from "react";
import Header from "../../../Components/Layout/Header/Header";
import Footer from "../../../Components/Layout/Footer/Footer";
import Accordion from "react-bootstrap/Accordion";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import combinedServices from "../../../shared/services/user-service";
import getLocalData from "../../../shared/localStorage/getData";
import categoryIcon from "../../../assets/images/cat_Icon.png";
import Swal from "sweetalert2";
import swal from "sweetalert";
import getRemoveData from "../../../shared/localStorage/removeData";
import CryptoJS from "crypto-js";
import userConstants from "../../../shared/constants/user-constants";

const MyOrders = () => {
  const navigate = useNavigate();
  const [productsData, setProductsData] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [userid, setUserid] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [subMembers, setSubmembers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [getOrderdata, setGetOrderdata] = useState(0);

  const totalPages = Math.ceil(totalProducts / limit);

  const secretKey = userConstants.CRYPTOSECRETKEY;

  const location = useLocation();
  const storeID = location.state?.storeID;
  console.log("storeID", storeID);

  useEffect(() => {
    const fetchSubMembers = async () => {
      try {
        let eventSubMember = await combinedServices.getAllSubMemberList(
          localStorage.getItem("parent_token")
        );
        setSubmembers(eventSubMember.data);
        setUserid(eventSubMember.data);
        if (eventSubMember.status == 401) {
          swal(eventSubMember.msg, "Please Re-login", "warning").then(() => {
            getRemoveData("user_info");
            localStorage.clear();
            window.location.href = "/login";
          });
        }
      } catch (error) {
        console.error("Error fetching Submembers:", error);
      }
    };
    fetchSubMembers();
  }, []);

  useEffect(() => {
    if (userid) {
      const userIds = userid.map((user) => user.id);
      console.log("userIds", userIds);

      const fetchOrders = async (userId) => {
        try {
          const orderResponse = await combinedServices.getOrdersforuser(
            [userId], // Pass single userId in the array
            page,
            limit,
            searchQuery,
            paymentStatus,
            orderStatus,
            storeID
          );
          if (orderResponse?.data?.data) {
            setProductsData((prevData) => [
              ...prevData,
              ...orderResponse.data.data
            ]);
            setTotalProducts(orderResponse.data.total || 0);
          }
        } catch (error) {
          console.error("Error fetching orders for userId:", userId, error);
        }
      };

      const fetchAllOrders = async () => {
        for (const userId of userIds) {
          await fetchOrders(userId); // Sequential calls
        }
      };

      fetchAllOrders();
    }
  }, [
    userid,
    page,
    limit,
    searchQuery,
    paymentStatus,
    orderStatus,
    getOrderdata
  ]);

  const handleUserChange = (e) => {
    setSelectedUserId(e.target.value);
    setUserid(e.target.value);
  };

  const groupedOrders = productsData.reduce((acc, order) => {
    if (!acc[order.order_id]) acc[order.order_id] = [];
    acc[order.order_id].push(order);
    return acc;
  }, {});

  const sortedGroupKeys = Object.keys(groupedOrders).sort(
    (a, b) =>
      new Date(groupedOrders[b][0].orderDate) -
      new Date(groupedOrders[a][0].orderDate)
  );

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
    setProductsData([]);
    setTotalProducts(0);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
      setProductsData([]);
      setTotalProducts(0);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
    setProductsData([]);
    setTotalProducts(0);
  };

  const handlePaymentStatusChange = (e) => {
    setPaymentStatus(e.target.value);
    setPage(1);
    setProductsData([]);
    setTotalProducts(0);
  };

  const handleOrderStatusChange = (e) => {
    setOrderStatus(e.target.value);
    setPage(1);
    setProductsData([]);
    setTotalProducts(0);
  };

  const formatDate = (dateString) => {
    return moment(dateString).format("MM/DD/YYYY HH:mm:ss");
  };

  const getStatusClass = (status, type) => {
    if (type === "payment") {
      return (
        {
          COMPLETED: "status-completed-delivered",
          PENDING: "status-pending",
          FAILED: "status-failed-cancelled"
        }[status] || "status-default"
      );
    }
    if (type === "order") {
      return (
        {
          Delivered: "status-completed-delivered",
          Pending: "status-pending",
          Cancelled: "status-failed-cancelled"
        }[status] || "status-default"
      );
    }
  };

  const cancelOrder = async (
    id,
    payment_id,
    price,
    inv_id,
    userId,
    product_id,
    attribute,
    product,
    storeid
  ) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to cancel this order?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "No, keep it"
      });

      if (result.isConfirmed) {
        setIsLoading(true);

        const data = {
          id: id,
          payment_id: payment_id,
          refundableAmount: price,
          inv_id: inv_id,
          storeid: storeid
        };

        const CancelOrderResponse = await combinedServices.CancelOrder(data);
        setRefreshTrigger((prev) => prev + 1);

        if (CancelOrderResponse.data.status === 200) {
          const parsedAttribute = JSON.parse(attribute);

          if (
            (parsedAttribute.Classes || parsedAttribute.Transponders) &&
            inv_id === 0 &&
            product === null
          ) {
            // Find the order_id for the current order
            const currentOrder = productsData.find(order => order.id === id);
            const orderId = currentOrder?.order_id;
            
            if (orderId) {
              // Find all orders with same order_id and price 0
              const ordersToCancel = productsData.filter(
                order => order.order_id === orderId && parseFloat(order.price) === 0
              );
              
              // Cancel all matching orders
              for (const orderToCancel of ordersToCancel) {
                if (orderToCancel.id !== id) { // Skip the already cancelled order
                  try {
                    const cancelData = {
                      id: orderToCancel.id,
                      payment_id: orderToCancel.payment_id,
                      refundableAmount: orderToCancel.price,
                      inv_id: orderToCancel.inv_id,
                      storeid: storeid
                    };
                    await combinedServices.CancelOrder(cancelData);
                  } catch (cancelError) {
                    // Skip already cancelled orders silently
                    console.log(`Order ${orderToCancel.id} already cancelled`);
                  }
                }
              }
            }
            
            const cancelUserEventEntryResponse =
              await combinedServices.cancelUserEventEntry({
                id: id,
                userID: userId,
                eventId: product_id
              });
            setRefreshTrigger((prev) => prev + 1);
            setProductsData([]);
            setGetOrderdata((prev) => prev + 1);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setProductsData([]);
            setGetOrderdata((prev) => prev + 1);
          }
          
          Swal.fire(
            "Cancelled!",
            "Your order has been successfully cancelled.",
            "success"
          );
        }
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      Swal.fire(
        "Error!",
        "An error occurred while cancelling the order.",
        "error"
      );
      setIsLoading(false);
    }
  };

  const encryptmainOrderId = (orderId) => {
    return CryptoJS.AES.encrypt(orderId, secretKey).toString();
  };

  const retryPayment = async (orderId) => {
    try {
      setIsLoading(true);

      const orderDetailsResponse = await combinedServices.getorder({
        orderID: orderId
      });
      const orderDetails = orderDetailsResponse.data.order;

      const regularCartItems = [];
      const ticketCartItems = [];
      const totalprice = [];

      const regularItemsToProcess = orderDetails.filter((item) => {
        const attributes = JSON.parse(item.attribute);
        totalprice.push(item.price);
        if (attributes.Classes || attributes.Transponders) {
          ticketCartItems.push({
            user_name: item.username,
            user_id: item.userId,
            classWiseTotal: item.price,
            pit_space: false,
            special_note: "",
            event_name: item.product_name,
            event_id: item.product_id,
            selectedClass: (attributes.Classes || []).map((name, index) => ({
              id: index + 1,
              name: name,
              index: index
            })),
            image: JSON.parse(item.image)[0],
            eventid: item.product_id
          });
          return false;
        }
        return true;
      });

      // Only proceed with event validation if there are ticket items
      if (ticketCartItems.length > 0 && ticketCartItems[0].eventid) {
        const validatedEvent = await combinedServices.getEvent({
          eventID: ticketCartItems[0].eventid
        });

        const currentDate = new Date();
        const registrationCloseDate = new Date(
          validatedEvent.data.eventParticipant.registration_close
        );

        if (
          validatedEvent.data.eventParticipant.event_status !== "upcoming" ||
          registrationCloseDate < currentDate
        ) {
          throw new Error("Race has been closed for registration");
        }

        const userEntrycheck = await combinedServices.userEventCheck({
          userID: ticketCartItems[0].user_id,
          eventID: ticketCartItems[0].event_id
        });
        if (userEntrycheck.data.alreadyEntered === true) {
          throw new Error("User is already entered in the EVent");
        }
      }
      const productIds = regularItemsToProcess.map((item) => item.product_id);

      const productTypesResponse = await Promise.all(
        productIds.map(async (productId) => {
          try {
            const productType = await combinedServices.getProductType({
              productID: productId
            });
            return {
              product_id: productId,
              product_type: productType.data
            };
          } catch (error) {
            alert(`Error fetching product type for ${productId}:`, +error);
            return {
              product_id: productId,
              product_type: "inventory"
            };
          }
        })
      );

      const productTypeMap = {};
      productTypesResponse.forEach((item) => {
        if (item) {
          productTypeMap[item.product_id] = item.product_type;
        }
      });

      regularItemsToProcess.forEach((item) => {
        const attributes = JSON.parse(item.attribute);
        regularCartItems.push({
          id: item.product_id,
          inv_id: item.inv_id,
          image: item.image,
          name: item.product_name,
          price: item.unit_price,
          quantity: item.quantity,
          attributes: attributes,
          product_type: productTypeMap[item.product_id]
        });
      });

      const validatedData = await combinedServices.validateCart(
        regularCartItems
      );
      const allValid = validatedData.data.data.every(
        (item) => item.isValid === true
      );

      if (!allValid) {
        throw new Error("Some Products are not available or Out of stock");
      }

      const encryptedmainOrderId = encryptmainOrderId(orderId);
      localStorage.setItem("temp_orderId", encryptedmainOrderId);

      const ticketItems = Array.isArray(ticketCartItems)
        ? ticketCartItems.map((ticket) => ({
          name: ticket.event_name,
          price: parseFloat(ticket.classWiseTotal || "0").toFixed(2),
          inv_id: ticket.event_id,
          quantity: 1,
          attributes: {
            Selected_Classes: Array.isArray(ticket.selectedClass)
              ? ticket.selectedClass.map((cls) => cls.name).join(", ")
              : "No Classes Selected",
            Pit_Space: ticket.pit_space ? "Yes" : "No",
            Special_Note: ticket.special_note || "None"
          },
          image: ticket.image || "",
          product_type: "event_ticket"
        }))
        : [];

      const mergedCartItems = [...regularCartItems, ...ticketItems];

      const orderData = {
        items: mergedCartItems,
        total: totalprice.reduce((sum, price) => sum + parseFloat(price), 0),
        orderId: orderId
      };

      const apiResponse = await combinedServices.shoppingCartPaypalpayment(
        orderData
      );

      if (apiResponse.data.status === 200) {
        const approvalUrl = apiResponse.data.data.approvalUrl;
        if (approvalUrl) {
          window.location.href = approvalUrl;
        }
      } else {
        throw new Error("Payment processing failed");
      }
    } catch (error) {
      console.error("Error in retryPayment:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message || "There was an error processing your order."
      });
    } finally {
      setIsLoading(false);
    }
  };

  const isWithin48Hours = (orderDate) => {
    const orderTime = new Date(orderDate).getTime();
    const currentTime = new Date().getTime();
    const hoursDiff = (currentTime - orderTime) / (1000 * 60 * 60);
    return hoursDiff <= 48;
  };

  const getRemainingTime = (orderDate) => {
    const orderTime = new Date(orderDate).getTime();
    const currentTime = new Date().getTime();
    const hoursDiff = (currentTime - orderTime) / (1000 * 60 * 60);
    const remainingHours = 48 - hoursDiff;

    if (remainingHours <= 0) return "Expired";

    const hours = Math.floor(remainingHours);
    const minutes = Math.floor((remainingHours - hours) * 60);

    return `${hours}h ${minutes}m remaining`;
  };

  return (
    <>
      <Header />
      <div className="dbAdminRight newDbRight myOrderCon">
        <div className="dbMid dbInner">
          <div className="dbMainHd">My Orders</div>
          {isLoading && (
            <div className="loadingOverlay">
              <div className="loadingSpinner"></div>
            </div>
          )}
          <div className="catFilterWrp">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="catFilterCont">
                <div className="filWrp">
                  <label className="label2">Showing</label>
                  <select
                    value={limit}
                    onChange={handleLimitChange}
                    className="form_ctrl ctrlDrop"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                  <span className="ent">entries</span>
                  <div className="filBtnWrp">
                    <label className="label2">Payment Status</label>
                    <select
                      value={paymentStatus}
                      onChange={handlePaymentStatusChange}
                      className="form_ctrl ctrlDrop"
                    >
                      <option value="">All Payment</option>
                      <option value="COMPLETED">Completed</option>
                      <option value="PENDING">Pending</option>
                      <option value="FAILED">Failed</option>
                      <option value="REFUNDED">Refunded</option>
                    </select>
                    {/* <span className="ent"></span>

                    <div className="srchGrp">
                      <label className="label2">Order Status</label>

                      <select
                        value={orderStatus}
                        onChange={handleOrderStatusChange}
                        className="form_ctrl ctrlDrop"
                      >
                        <option value="">All Orders</option>
                        <option value="Delivered">Delivered</option>
                        <option value="Pending">Pending</option>
                        <option value="Cancelled">Cancelled</option>
                      </select>
                    </div> */}
                  </div>
                  <span className="ent"></span>
                  <div className="srchGrp">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      className="form_ctrl ctrlSrch"
                      placeholder="Search with Product Name and Order ID"
                      style={{ width: "400px", marginRight: "20px" }}
                    />
                  </div>
                  {/* <div className="srchGrp">
                    <label className="label2">Username</label>
                    <select
                      value={selectedUserId} // Assuming you have a state for selected user ID
                      onChange={handleUserChange} // Your change handler
                      className="form_ctrl ctrlDrop"
                    >
                      {subMembers.map((member) => (
                        <option key={member.id} value={member.id}>
                          {member.user_firstname} {member.user_lastname}
                        </option>
                      ))}
                    </select>
                  </div> */}
                </div>
              </div>
            </form>
          </div>
          <div className="listTablWrp">
            <div className="tblWrp">
              {/* Table headers */}
              <table>
                <thead>
                  <tr>
                    <th>UserName</th>
                    <th>Product / Event Name</th>
                    <th>Description</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Payment Status</th>
                    <th>Special Note</th>
                    <th>Transaction ID</th>
                    <th>Ordered Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
              </table>

              <Accordion defaultActiveKey="0">
                {sortedGroupKeys.map((orderId, idx) => {
                  const ordersWithSameId = groupedOrders[orderId];
                  const srNo = (page - 1) * limit + idx + 1;

                  return (
                    <Accordion.Item eventKey={String(idx)} key={orderId}>
                      <Accordion.Header>
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <div className="d-flex align-items-center">
                            <div>
                              <strong>Order ID:</strong> {orderId}{" "}
                              <strong>Order Date:</strong>{" "}
                              {formatDate(ordersWithSameId[0]?.orderDate) ||
                                "N/A"}{" "}
                            </div>
                          </div>
                          {(ordersWithSameId[0].paymentStatus === "FAILED" ||
                            ordersWithSameId[0].paymentStatus === "PENDING") &&
                            (isWithin48Hours(ordersWithSameId[0].orderDate) ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px"
                                }}
                              >
                                <span
                                  style={{ color: "#666", fontSize: "12px" }}
                                >
                                  {getRemainingTime(
                                    ordersWithSameId[0].orderDate
                                  )}
                                </span>
                                <button
                                  className="status-badge"
                                  style={{
                                    backgroundColor: "#dc3545",
                                    color: "#fff",
                                    cursor: "pointer",
                                    padding: "4px 8px",
                                    borderRadius: "15px",
                                    border: "none",
                                    fontSize: "15px",
                                    whiteSpace: "nowrap",
                                    height: "35px",
                                    width: "140px"
                                  }}
                                  onClick={(e) => {
                                    retryPayment(orderId);
                                  }}
                                >
                                  RETRY PAYMENT
                                </button>
                              </div>
                            ) : (
                              <span style={{ color: "#999", fontSize: "12px" }}>
                                Retry payment window expired
                              </span>
                            ))}
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <table>
                          <tbody>
                            {ordersWithSameId.map((order, index) => {
                              const attributes = JSON.parse(
                                order.attribute || "{}"
                              );
                              const productImages = (() => {
                                try {
                                  if (
                                    !order.product ||
                                    typeof order.product !== "object"
                                  )
                                    return [categoryIcon];
                                  if (
                                    !order.product.images ||
                                    order.product.images === "null"
                                  )
                                    return [categoryIcon];
                                  const parsedImages = JSON.parse(
                                    order.product.images
                                  );
                                  return Array.isArray(parsedImages) &&
                                    parsedImages.length > 0 &&
                                    parsedImages[0] !== null
                                    ? parsedImages
                                    : [categoryIcon];
                                } catch {
                                  return [categoryIcon];
                                }
                              })();

                              return (
                                <tr key={`${order.id}-${index}`}>
                                  <td className="orderTableminweidth">
                                    {order.username}
                                  </td>{" "}
                                  <td className="td1">
                                    <div className="catPara">
                                      <img
                                        src={productImages[0] || ""}
                                        alt={order.product_name}
                                        className="productImage"
                                      />
                                      {order.product_name}
                                    </div>
                                  </td>
                                  <td className="td1">
                                    {Object.entries(attributes).map(
                                      ([key, value]) => {
                                        const displayValue = Array.isArray(
                                          value
                                        )
                                          ? value.join(", ")
                                          : value;

                                        return (
                                          <div key={key}>
                                            <strong>{key}:</strong>{" "}
                                            {displayValue}
                                          </div>
                                        );
                                      }
                                    )}
                                  </td>
                                  <td className="td1"> ${order.price}</td>
                                  <td className="td1">{order.quantity}</td>
                                  <td className="td1">
                                    <span
                                      className={`status-badge ${getStatusClass(
                                        order.paymentStatus,
                                        "payment"
                                      )}`}
                                    >
                                      {order.paymentStatus}
                                    </span>
                                  </td>
                                  <td className="td1">
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                      <span className="catPara">
                                        {order.special_note || "N/A"}
                                      </span>
                                     
                                    </div>
                                  </td>
                                  <td className="td1">
                                    {order.transaction_id || "N/A"}
                                  </td>
                                  <td>
                                    {formatDate(order.orderDate) || "N/A"}
                                  </td>
                                  <td className="td1">
                                    <button
                                      className="status-badge"
                                      style={{
                                        backgroundColor:
                                          order.paymentStatus === "COMPLETED" &&
                                            order.orderStatus === "Pending"
                                            ? "#ff4d4f" // Red when active
                                            : "#d3d3d3", // Grey when disabled
                                        color:
                                          order.paymentStatus === "COMPLETED" &&
                                            order.orderStatus === "Pending"
                                            ? "#fff"
                                            : "#888",
                                        cursor:
                                          order.paymentStatus === "COMPLETED" &&
                                            order.orderStatus === "Pending"
                                            ? "pointer"
                                            : "not-allowed",
                                        opacity:
                                          order.paymentStatus === "COMPLETED" &&
                                            order.orderStatus === "Pending"
                                            ? 1
                                            : 0.7 // Slightly faded if disabled
                                      }}
                                      disabled={
                                        !(
                                          order.paymentStatus === "COMPLETED" &&
                                          order.orderStatus === "Pending"
                                        )
                                      }
                                      onClick={() => {
                                        cancelOrder(
                                          order.id,
                                          order.payment_id,
                                          order.price,
                                          order.inv_id,
                                          order.userId,
                                          order.product_id,
                                          order.attribute,
                                          order.product,
                                          order.store_id
                                        );
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            </div>
            <div className="tblPagiWrp">
              <ul className="pagination namPagi">
                <li>
                  <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                  >
                    Prev
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, index) => (
                  <li key={index}>
                    <button
                      className={page === index + 1 ? "active" : ""}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li>
                  <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === totalPages}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default MyOrders;
